{
  "timeline": {
    "title": "O seu período de teste gratuito",
    "day0Label": "Hoje",
    "day0Description": "Início do teste",
    "reminderLabel": "Dia {{day}}",
    "reminderDescription": "Email de lembrete enviado",
    "trialEndLabel": "Dia {{days}}",
    "trialEndDescription": "Fim do teste — adicione um cartão para continuar a usar o AllDrivers"
  },
  "banner": {
    "honestReminder": "Período de teste: faltam {{daysRemaining}} de {{trialDays}} dias",
    "trialEndingSoon": "O seu período de teste termina em {{daysRemaining}} dias",
    "trialEndedOwner": "O seu período de teste terminou — adicione um método de pagamento para continuar",
    "trialEndedDriverGrace": "O período de teste da sua empresa terminou. Restam-lhe {{graceDaysRemaining}} dias — pague a sua própria licença para continuar a conduzir"
  },
  "expired": {
    "titleOwner": "O período de teste terminou",
    "titleDriver": "O acesso da sua empresa terminou",
    "bodyOwner": "Tal como avisámos na timeline do teste, para continuar a usar o AllDrivers é preciso ativar a subscrição. Os seus dados estão guardados.",
    "bodyDriver": "O período de tolerância da sua empresa terminou. Pague a sua própria licença para continuar a conduzir — ou fale com o seu gestor.",
    "ctaOwner": "Ativar subscrição",
    "subscriptionError": "Não foi possível criar a assinatura.",
    "ctaDriver": "Pagar a minha licença"
  },
  "selfPay": {
    "title": "Pague a sua própria licença",
    "body": "Continue a conduzir com o AllDrivers mesmo que a sua empresa deixe de pagar — a licença fica sua, associada à sua conta.",
    "cardUpfront": "Teste gratuito de {{days}} dias — o cartão é pedido já, mas só é cobrado no fim do teste.",
    "cta": "Ativar a minha licença",
    "checkoutError": "Não foi possível iniciar o pagamento. Tente novamente.",
    "exitDashboard": "Voltar ao início",
    "exitLogout": "Sair",
    "unknownBody": "Não foi possível confirmar a sua licença. Verifique a ligação e tente novamente.",
    "retry": "Tentar novamente"
  }
}
